import React, { useState, useReducer } from "react";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab/";
import NtkButton from "../services/common/NtkButton";
import NtkInputField from "./NtkInputField";
const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "3em",
    color: theme.palette.text.secondary,
    marginTop: "1.5em",
    borderRadius: "5px",
    [theme.breakpoints.down("xs")]: {
      padding: "0.5em",
    },
  },
  alert: {
    margin: "20px auto",
    textAlign: "left",
    width: "fit-content",
  },
  gridStyle: {
    margin: "0 auto",
    [theme.breakpoints.down("xs")]: {
      width: "15em",
    },
  },
}));

const ContactSection = () => {
  const classes = useStyles();
  const [isSent, setIsSent] = useState(false);
  const [contactForm, setContactForm] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      name: "",
      email: "",
      organization: "",
      interestedIn: "",
      message: "",
    }
  );

  const handleChange = (e) => {
    const name = e.target.name;
    const newValue = e.target.value;
    setContactForm({ [name]: newValue });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSent(true);
    let clearPayload = {
      name: "",
      email: "",
      organization: "",
      interestedIn: "",
      message: "",
    };
    setContactForm(clearPayload);
  };

  return (
    <Container maxWidth={false}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Container maxWidth="md">
          <Paper elevation={6} className={classes.paper}>
            <Grid
              direction="row"
              className={classes.gridStyle}
              container
              justify="center"
              spacing={3}
            >
              <Grid item sm>
                <NtkInputField
                  value={contactForm.name}
                  onChange={handleChange}
                  required
                  name="name"
                  fullWidth
                  type={"text"}
                  placeholder="Name"
                ></NtkInputField>
              </Grid>
              <Grid item sm>
                <NtkInputField
                  value={contactForm.email}
                  onChange={handleChange}
                  required
                  name="email"
                  fullWidth
                  type={"email"}
                  placeholder="Email"
                ></NtkInputField>
              </Grid>
              <Grid
                direction="row"
                container
                justify="center"
                spacing={3}
                className={classes.gridStyle}
              >
                <Grid item sm>
                  <NtkInputField
                    value={contactForm.organization}
                    onChange={handleChange}
                    name="organization"
                    fullWidth
                    type={"text"}
                    placeholder="Organization"
                  ></NtkInputField>
                </Grid>
                <Grid item sm>
                  <NtkInputField
                    value={contactForm.interestedIn}
                    onChange={handleChange}
                    required
                    name="interestedIn"
                    fullWidth
                    type={"text"}
                    placeholder="Are you interested in"
                  ></NtkInputField>
                </Grid>
              </Grid>

              <Grid
                spacing={3}
                direction="row"
                className={classes.gridStyle}
                container
                justify="center"
              >
                <Grid item sm>
                  <NtkInputField
                    name="message"
                    value={contactForm.message}
                    onChange={handleChange}
                    fullWidth
                    required
                    type="text"
                    placeholder="Message"
                    rows={9}
                    multiline={true}
                  ></NtkInputField>
                </Grid>
              </Grid>
            </Grid>
            {isSent ? (
              <Container>
                <Alert className={classes.alert} severity="success">
                  <AlertTitle>Send</AlertTitle>
                  Thank you for contacting us. We' ll respond you as soon as
                  possible.
                </Alert>
              </Container>
            ) : (
              <NtkButton title="Submit" type="submit" />
            )}
          </Paper>
        </Container>
      </form>
    </Container>
  );
};

export default ContactSection;
